module.exports = __webpack_public_path__ + "static/assets/96f0c6b4e63eb64f6822a372d6c426ec.svg";